import "../styles/bikecard.css";

export default function BikeCard({ name, price, image }) {
  const handleWhatsApp = () => {
    const message = `Hi VK Bike On Rent,

I want to enquire about renting this bike:

Bike: ${name}
Starting Price: ₹${price}/day
Location: Udaipur

Please share availability, rental terms and booking details.`;

    const whatsappUrl = `https://wa.me/919983765215?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <article className="bike-card">
      <div className="bike-image-wrapper">
        <img
          src={image}
          alt={`${name} available for rent in Udaipur`}
          className="bike-image"
          loading="lazy"
          decoding="async"
          width="400"
          height="220"
          onError={(event) => {
            event.currentTarget.onerror = null;
            event.currentTarget.src = "/bike-placeholder.jpg";
          }}
        />
      </div>

      <div className="bike-content">
        <h3 className="bike-title">
          {name}
        </h3>

        <p className="bike-location">
          Bike rental in Udaipur
        </p>

        <p className="bike-price">
          <span className="price-label">
            From{" "}
          </span>

          <strong>
            ₹{price}
          </strong>

          <span className="price-period">
            {" "}/ day
          </span>
        </p>

        <button
          type="button"
          className="bike-btn"
          onClick={handleWhatsApp}
          aria-label={`Enquire about renting ${name} in Udaipur on WhatsApp`}
        >
          📲 Book on WhatsApp
        </button>
      </div>
    </article>
  );
}

 